

import { Button, Modal } from 'react-bootstrap';
import {
    Dropdown,
    DropdownButton,
    Nav,
    NavDropdown,
    Navbar,
    OverlayTrigger,
    Popover
} from 'react-bootstrap';
import React, { useContext, useEffect, useState } from "react";
import { MainContext } from "../store/mainContext";
import ConfirmDialog from './ConfirmDialog'
import http from "../Services/httpService";
import noronServices from "../Services/noronServices";
import { toast } from "react-toastify";
import Select from 'react-select'
import OilChangeEdit from './OilChangeEdit'
import OilChangeList from './OilChangeList'

export default function OilChange({ show, handleClose, device }) {
    const { devices, changed, doChanged, setDefaultDevice, setRoutePoint, command, setCommand } = useContext(MainContext);
    const [showOilChangeEdit, setShowOilChangeEdit] = useState(false)
    const [doRefresh, setDoRefresh] = useState(false)
    const [id, setId] = useState(0)
    const doEdit = (e, id) => {
        console.log('edit', id)
        e.preventDefault();
        setId(id);
        setShowOilChangeEdit(true);
    }
    return (
        <>
            {showOilChangeEdit &&
                <OilChangeEdit
                    show={showOilChangeEdit}
                    handleClose={(e, form) => {
                        setShowOilChangeEdit(false)
                        if (form)
                            setDoRefresh(p => ++p);
                    }}
                    id={id}
                />
            }
            <Modal show={show} onHide={handleClose} id="modalPatient" centered size="lg" scrollable>
                <Modal.Header closeButton>
                    <Modal.Title className="colorRed">سرویس نگهداری خودرو   </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='roe mt-3 mb-3'>
                        <div className='col'>
                            <button
                                onClick={e => {
                                    e.preventDefault();
                                    setId(0);
                                    setShowOilChangeEdit(true);
                                }}
                                className="btn btn-primary">
                                جدید
                            </button>
                        </div>
                    </div>
                    <OilChangeList
                        doRefresh={doRefresh}
                        doEdit={doEdit} />
                </Modal.Body>
                <Modal.Footer>                </Modal.Footer>
            </Modal>
        </>

    );

}
